const IMAGE_CDN_BASE = "https://padelresort.b-cdn.net";

export function buildContentfulImageUrl(
  rawUrl?: string | null,
  transformParams?: string,
) {
  if (!rawUrl) {
    return "";
  }

  const url = rawUrl.trim();
  if (!url) {
    return "";
  }

  const normalizedUrl = url.startsWith("//") ? `https:${url}` : url;
  const params = transformParams?.replace(/^[?&]/, "") ?? "";
  const appendParams = (targetUrl: string) => {
    if (!params) {
      return targetUrl;
    }

    return `${targetUrl}${targetUrl.includes("?") ? "&" : "?"}${params}`;
  };
  const toCdnUrl = (path: string) => `${IMAGE_CDN_BASE}${path}`;

  if (url.startsWith("/")) {
    return appendParams(toCdnUrl(url));
  }

  try {
    const parsedUrl = new URL(normalizedUrl);
    const pathWithQuery = `${parsedUrl.pathname}${parsedUrl.search}`;
    const isContentfulAsset = parsedUrl.hostname.includes("ctfassets.net");
    const isSameSiteAsset =
      parsedUrl.hostname.includes("padel-resort.netlify.app") ||
      parsedUrl.hostname.includes("padelresort.it");

    if (isContentfulAsset || isSameSiteAsset) {
      return appendParams(toCdnUrl(pathWithQuery));
    }
  } catch {
    return normalizedUrl;
  }

  return normalizedUrl;
}
